import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
const HOME_LABEL = 'Úvod';
function homeCrumb() {
  return {
    label: HOME_LABEL,
    href: app.route('index')
  };
}
function getTagAncestors(tag) {
  const ancestors = [];
  let parent = tag.parent();
  while (parent) {
    ancestors.unshift(parent);
    parent = parent.parent();
  }
  return ancestors;
}
function addTagTrail(crumbs, tag) {
  if (!tag) {
    return;
  }
  for (const ancestor of getTagAncestors(tag)) {
    crumbs.push({
      label: ancestor.name(),
      href: app.route('tag', {
        tags: ancestor.slug()
      })
    });
  }
  crumbs.push({
    label: tag.name(),
    href: null
  });
}
function getDiscussionTag(discussion) {
  const tags = discussion.tags();
  if (!tags || !tags.length) {
    return null;
  }
  return tags.find(tag => tag.position() !== null) || tags[0];
}
function translate(key) {
  return extractText(app.translator.trans(key));
}
export default function buildCrumbs() {
  const routeName = app.current.get('routeName');
  if (routeName === 'index') {
    return null;
  }
  const crumbs = [homeCrumb()];
  if (routeName === 'tag') {
    var _app$currentTag;
    const tag = (_app$currentTag = app.currentTag) == null ? void 0 : _app$currentTag.call(app);
    if (tag) {
      addTagTrail(crumbs, tag);
    }
    return crumbs.length > 1 ? crumbs : null;
  }
  if (routeName === 'tags') {
    crumbs.push({
      label: translate('flarum-tags.forum.index.tags_link'),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'diaTheme.terms') {
    crumbs.push({
      label: 'Obchodní podmínky',
      href: null
    });
    return crumbs;
  }
  if (routeName === 'posts') {
    crumbs.push({
      label: translate('core.forum.posts.meta_title_text'),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'discussion' || routeName === 'discussion.near') {
    const discussion = app.current.get('discussion');
    if (!discussion) {
      return null;
    }
    const tag = getDiscussionTag(discussion);
    if (tag) {
      for (const ancestor of getTagAncestors(tag)) {
        crumbs.push({
          label: ancestor.name(),
          href: app.route('tag', {
            tags: ancestor.slug()
          })
        });
      }
      crumbs.push({
        label: tag.name(),
        href: app.route('tag', {
          tags: tag.slug()
        })
      });
    }
    crumbs.push({
      label: discussion.title(),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'user' || routeName === 'user.posts') {
    const user = app.current.get('user');
    if (!user) {
      return null;
    }
    crumbs.push({
      label: user.displayName(),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'user.discussions') {
    const user = app.current.get('user');
    if (!user) {
      return null;
    }
    crumbs.push({
      label: user.displayName(),
      href: app.route('user', {
        username: user.slug()
      })
    });
    crumbs.push({
      label: translate('core.forum.user.discussions_link'),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'user.security') {
    const user = app.current.get('user');
    if (!user) {
      return null;
    }
    crumbs.push({
      label: user.displayName(),
      href: app.route('user', {
        username: user.slug()
      })
    });
    crumbs.push({
      label: translate('core.forum.security.title'),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'settings') {
    crumbs.push({
      label: translate('core.forum.settings.title'),
      href: null
    });
    return crumbs;
  }
  if (routeName === 'notifications') {
    crumbs.push({
      label: translate('core.forum.notifications.title'),
      href: null
    });
    return crumbs;
  }
  return null;
}
flarum.reg.add('dia-theme', 'forum/features/breadcrumbs/buildCrumbs', buildCrumbs);